import { HP, legSwing, pt } from '../enemy-parts';
import { clamp } from '../../core/math';
/* ============================================================
   家族 BAR 桿 —— 水平長桿
   ============================================================

   由 `tools/port-families.mjs` 從 `enemy_sample_ani.html` §5 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-families.mjs --check`（逐一比對數字字面值序列）。

   本族成員（威脅色決定身分，剪影決定家族）：
     SPULE   amb 線圈　狙擊・遠距
     SENSE   red 鐮　旋掃・近身
     HARFE   vio 豎琴　齊射・覆蓋
     RIPPE   azu 肋　深層・連結增益

   `parts` 的材質名（armor/dark/trim/glow/armorE/glowE）由
   `enemy-parts.ts` 的 `enemyPalette(tint)` 解析 —— 型別表只寫形狀。 */

export var BAR = [
  /* ─ 6 ─────────────────────────────────────────────────────────
     SPULE 線圈 —— 剪影是全表唯一的「水平長桿」，比誰都寬、比誰都矮。
     線圈依序亮＝倒數。橙色＋預警線，代表這一發可以被地形擋掉。 */
  {
    id:'spule', fam:'bar', code:'SPULE', zh:'線圈', role:'狙擊・遠距', tint:'amb',
    sil:'水平長桿＋三環', h:0.86, w:0.72, wt:0.9,
    spd:1.0, turn:1.2, gait:1.4, rng:8.0, tTel:1.15, tAtk:0.22, tRec:1.30,
    q0:{lg:1, br:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'速射', q:{br:0.78}, sp:1.30, sc:0.88},
          {n:'長軌', q:{br:1.40}, sp:0.70, sc:1.12}],
    parts:[
      pt('bev','dark', [0.42,0.38,0.58],[0,0.52,-0.38]),
      pt('cyl','trim', [0.18,1.84,0.18],[0,0.56,0.62],[HP,0,0], function(P,o){
          P.sy *= o.q.br; P.z += (o.q.br-1)*0.90; P.z -= o.atk*0.30; }),
      pt('tor','glow', [0.44,0.44,0.75],[0,0.56,0.18],null, function(P,o){
          var k = 1 + 1.5*clamp(o.tel*3,0,1);   P.sx *= k; P.sy *= k; P.z -= o.atk*0.30; }),
      pt('tor','glow', [0.41,0.41,0.75],[0,0.56,0.66],null, function(P,o){
          var k = 1 + 1.5*clamp(o.tel*3-1,0,1); P.sx *= k; P.sy *= k;
          P.z += (o.q.br-1)*0.55; P.z -= o.atk*0.30; }),
      pt('tor','glow', [0.38,0.38,0.75],[0,0.56,1.14],null, function(P,o){
          var k = 1 + 1.5*clamp(o.tel*3-2,0,1); P.sx *= k; P.sy *= k;
          P.z += (o.q.br-1)*1.30; P.z -= o.atk*0.30; }),
      pt('cyl','trim', [0.12,0.66,0.12],[ 0.27,0.30,0.06],[0,0,0.46], function(P,o){
          P.rz += o.tel*0.26; }),
      pt('cyl','trim', [0.12,0.66,0.12],[-0.27,0.30,0.06],[0,0,-0.46], function(P,o){
          P.rz -= o.tel*0.26; })
    ],
    ex:[ pt('box','armorE',[0.52,0.18,0.62],[0,0.76,-0.36],[0.24,0,0]),
         pt('cyl','armorE',[0.14,0.50,0.14],[ 0.26,0.86,-0.44],[0.3,0,0.24]),
         pt('cyl','armorE',[0.14,0.50,0.14],[-0.26,0.86,-0.44],[0.3,0,-0.24]),
         pt('tor','glowE',[0.50,0.50,0.7],[0,0.56,1.50]),
         pt('box','glowE',[0.05,0.05,1.40],[0,0.72,0.62]) ],
    pose:function(o){
      o.ry = 0.02*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = -o.tel*0.05 + o.atk*0.10;
      o.rr = 0;
      o.rz = -o.atk*0.24;
    }
  },
  /* ── 家族 BAR 桿 ── 水平長桿，全表最扁最長。amb 是 SPULE。 */
  {
    id:'sense', fam:'bar', code:'SENSE', zh:'鐮', role:'旋掃・近身', tint:'red',
    sil:'水平長桿＋旋轉橫刃', h:1.02, w:1.80, wt:1.6,
    spd:2.4, turn:2.4, gait:2.2, rng:2.2, tTel:0.42, tAtk:0.46, tRec:0.65,
    q0:{lg:1, bl:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'短鐮', q:{bl:0.80}, sp:1.42, sc:0.88},
          {n:'長鐮', q:{bl:1.36}, sp:0.76, sc:1.14}],
    parts:[
      pt('cyl','dark', [0.34,0.62,0.34],[0,0.50,0]),
      pt('box','armor',[1.76,0.10,0.26],[0,0.74,0],null, function(P,o){
          P.sx *= o.q.bl; P.ry += o.t*(0.7 + 9.0*o.atk) + o.tel*1.2; }),
      pt('box','armor',[0.26,0.10,1.44],[0,0.66,0],null, function(P,o){
          P.sz *= o.q.bl; P.ry += o.t*(0.7 + 9.0*o.atk) + o.tel*1.2; }),
      pt('oct','glow', [0.36,0.36,0.36],[0,0.70,0],null, function(P,o){
          var k = 1 + 1.4*o.tel + 1.6*o.atk; P.sx*=k; P.sy*=k; P.sz*=k; }),
      pt('cyl','trim', [0.22,0.50,0.22],[ 0.26,0.25,0],null, legSwing( 1,0.25,0.34)),
      pt('cyl','trim', [0.22,0.50,0.22],[-0.26,0.25,0],null, legSwing(-1,0.25,0.34))
    ],
    ex:[ pt('box','glowE',[1.90,0.05,0.10],[0,0.78,0],null, function(P,o){
          P.ry += o.t*(0.7 + 9.0*o.atk) + o.tel*1.2; }),
         pt('cyl','armorE',[0.42,0.20,0.42],[0,0.88,0]) ],
    pose:function(o){
      o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.05 + 0.05*o.mv - o.tel*0.10;
      o.rz = o.atk*0.40;
    }
  },
  {
    id:'harfe', fam:'bar', code:'HARFE', zh:'豎琴', role:'齊射・覆蓋', tint:'vio',
    sil:'水平長桿＋三管並列', h:1.06, w:1.52, wt:0.8,
    spd:1.1, turn:1.2, gait:1.5, rng:6.8, tTel:1.00, tAtk:0.35, tRec:1.25,
    q0:{lg:1, bl:1},
    vars:[{n:'標準', q:{},        sp:1.00, sc:1.00},
          {n:'速射', q:{bl:0.80}, sp:1.32, sc:0.90},
          {n:'長管', q:{bl:1.40}, sp:0.70, sc:1.14}],
    parts:[
      pt('bev','dark', [0.86,0.40,0.66],[0,0.28,0]),
      pt('cyl','armor',[0.18,0.96,0.18],[ 0.44,0.70,0.10],[HP-0.24,0,0], function(P,o){
          P.sy *= o.q.bl; P.rx -= o.tel*0.18; P.z -= o.atk*0.20; }),
      pt('cyl','armor',[0.18,1.16,0.18],[0,0.76,0.10],[HP-0.30,0,0], function(P,o){
          P.sy *= o.q.bl; P.rx -= o.tel*0.18; P.z -= o.atk*0.20; }),
      pt('cyl','armor',[0.18,0.96,0.18],[-0.44,0.70,0.10],[HP-0.24,0,0], function(P,o){
          P.sy *= o.q.bl; P.rx -= o.tel*0.18; P.z -= o.atk*0.20; }),
      pt('box','glow', [1.06,0.08,0.08],[0,0.52,0.06],null, function(P,o){
          P.sy *= 1 + 2.6*o.tel; P.sz *= 1 + 2.6*o.tel; }),
      pt('bev','trim', [0.28,0.24,0.56],[ 0.42,0.12,0.02], null, legSwing( 1,0.12,0.16)),
      pt('bev','trim', [0.28,0.24,0.56],[-0.42,0.12,0.02], null, legSwing(-1,0.12,0.16))
    ],
    ex:[ pt('box','armorE',[0.90,0.16,0.40],[0,0.44,-0.26],[0.22,0,0]),
         pt('tor','glowE',[0.34,0.34,0.5],[0,0.94,0.62],[0.30,0,0]) ],
    pose:function(o){
      o.ry = 0.02*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.03 + 0.03*o.mv - o.tel*0.12 + o.atk*0.20;
    }
  },
  {
    id:'rippe', fam:'bar', deep:1, code:'RIPPE', zh:'肋', role:'深層・連結增益', tint:'azu',
    sil:'水平骨狀桿＋中央洞', h:1.00, w:1.66, wt:0.6,
    spd:1.2, turn:1.3, gait:1.5, rng:5.8, tTel:1.10, tAtk:0.55, tRec:1.30,
    q0:{lg:1, bl:1},
    vars:[{n:'標準', q:{}, sp:1.00, sc:1.00},
          {n:'短肋', q:{bl:0.80}, sp:1.38, sc:0.90},
          {n:'長肋', q:{bl:1.40}, sp:0.70, sc:1.14}],
    parts:[
      pt('cyl','armor',[0.20,1.60,0.20],[0.06,0.72,0],[0,0,HP-0.14], function(P,o){
          P.sy *= o.q.bl; }),
      pt('cone','armor',[0.22,0.52,0.22],[ 0.84,0.80,0],[0,0,-HP], function(P,o){ P.x *= o.q.bl; }),
      pt('cone','armor',[0.18,0.44,0.18],[-0.76,0.62,0],[0,0, HP], function(P,o){ P.x *= o.q.bl; }),
      pt('oct','void',[0.44,0.44,0.44],[0.06,0.74,0.10]),
      pt('tor','glow',[0.80,0.80,0.36],[0.06,0.74,0.10],[HP,0.3,0], function(P,o){
          P.rz += o.t*(0.6 + 4*o.tel);
          var k = 1 + 1.0*o.tel + 1.6*o.atk*(1-o.atk); P.sx*=k; P.sy*=k; }),
      pt('cyl','trim',[0.20,0.56,0.20],[ 0.26,0.28,-0.04], null, legSwing( 1,0.28,0.26)),
      pt('cyl','trim',[0.18,0.48,0.18],[-0.22,0.24, 0.06], null, legSwing(-1,0.24,0.30))
    ],
    ex:[ pt('tor','glowE',[1.10,1.10,0.24],[0.06,0.74,0.10],[0,HP,0]),
         pt('cone','armorE',[0.16,0.36,0.16],[0.30,1.00,-0.14],[-0.4,0,0.3]) ],
    pose:function(o){ o.ry = 0.03*Math.sin(o.ph*2*Math.PI * 2)*o.mv;
      o.rp = 0.04 + 0.03*o.mv; o.rr = 0.09 + 0.08*Math.sin(o.ph*Math.PI * 2)*o.mv; }
  }
];
